import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedTenantId } from "../store/user/selectors";
import { getCasesTypeByTenantId } from "../store/cases/thunks";
import { selectCasesState } from "../store/cases/selectors";

export const useTenantCases = () => {
  const dispatch = useDispatch();
  const selectedTenantId = useSelector(selectSelectedTenantId);
  const { caseTypesByTenants, loading } = useSelector(selectCasesState);

  useEffect(() => {
    if (selectedTenantId && !caseTypesByTenants?.[selectedTenantId]) {
      dispatch(
        getCasesTypeByTenantId({
          tenant_id: selectedTenantId,
        }),
      );
    }
  }, [selectedTenantId, caseTypesByTenants]);

  const cases = useMemo(() => {
    return caseTypesByTenants[selectedTenantId] || [];
  }, [caseTypesByTenants, selectedTenantId]);

  return { cases, loading, selectedTenantId };
};
